import { IconButton } from '../IconButton/IconButton.es.js';
import styled from 'styled-components';
var Action = styled(IconButton).attrs(function () {
  return {
    label: "",
    variant: "subtle",
    isRounded: true,
    size: "sm",
    hideTooltip: true
  };
}).withConfig({
  componentId: "d2cy5t-0"
})([""]);
Action.displayName = "FeatureCard.Action";
export { Action };